module.exports = __webpack_public_path__ + "img/driver.bbb1f794.svg";